module.exports = __webpack_public_path__ + "img/remainder3.5bed0071.svg";